export default function Footer() {
    return (
        <footer
            data-testid="site-footer"
            className="border-t border-white/10 bg-[#060C1B] py-12"
        >
            <div className="mx-auto flex max-w-7xl flex-col items-start justify-between gap-8 px-5 sm:px-8 lg:flex-row lg:items-center lg:px-12">
                <div>
                    <div>
                        <img
                            src="/images/logo.png"
                            alt="Value Add Management"
                            className="h-8 w-auto"
                        />
                    </div>
                    <p className="mt-2 text-[11px] uppercase tracking-[0.25em] text-slate-500">
                        Multifamily Operations. Performance. Value Creation.
                    </p>
                </div>
                <p className="text-sm text-slate-500">
                    (305) 697-9450 · info@valueaddmanagement.com
                </p>
                <p className="text-xs text-slate-600">
                    © 2026 Value Add Management LLC. All rights reserved.
                </p>
            </div>
        </footer>
    );
}
